import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const HamburgerIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7C0 7.55229 0.447716 8 1 8L23 8C23.5523 8 24 7.55228 24 7C24 6.44772 23.5523 6 23 6H1C0.447715 6 0 6.44772 0 7ZM24 17C24 16.4477 23.5523 16 23 16L1 16C0.447716 16 0 16.4477 0 17C0 17.5523 0.447716 18 1 18L23 18C23.5523 18 24 17.5523 24 17Z"
      />
    </Icon>
  );
};
